module.exports = __webpack_public_path__ + "static/media/white-map-pin.571a16e9.svg";